module.exports = __webpack_public_path__ + "static/media/wall1.5ff78c77.jpg";